import { Link, Button } from '@mui/material';
import Stack, { StackProps } from '@mui/material/Stack';

import { useTranslate } from 'src/locales';

import Iconify from '../iconify';

// ----------------------------------------------------------------------

type Props = StackProps & {
  action?: React.ReactNode;
};

export default function ChromeExtensionLink({ ...other }: Props) {
  const { t } = useTranslate();

  return (
    <Stack
      id="extension-button"
      flexDirection="row"
      sx={{
        mr: -0.5,
      }}
      {...other}
    >
      <Button
        sx={{
          fontSize: 12,
          py: 1,
          px: 2,
          backgroundColor: '#ECF0F3',
          ':hover': {
            backgroundColor: '#DDE2E6',
          },
        }}
        endIcon={<Iconify icon="fa:chrome" color="#AAB2BA" />}
        LinkComponent={Link}
        href="https://chromewebstore.google.com/detail/jobtetris-quick-add-job-t/fnemkbephkkkbfhmldcfmkfccchjoljg"
        target="_blank"
        rel="noopener"
      >
        {t('auth.extension.title')}
      </Button>
    </Stack>
  );
}
